module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAS9JREFUKBVjYMAFmi9dYWi6PJXh/38mbEqwCoIV/mc8zMDwP4uh5cpChlX/mdE149ZYq5PFwMg4HWhjDMPNy8sZ9v9nQdbMiMzBym6+1Mfwn6EQKLeRQYM5jCFM+xdIHW4bYabU6hUBbW4Hcv0Zbv7dyDD/PgdIirCNMANaLtUx/GNoBOrYxyAm4ssIDLnpDIz/DWDy+GlGQ6Cf2YEuOAD0MDC4/xNpM8x9QPUwJn6LQLLNl2qBFjSBncoh5ocSxDh1N11uBTqxCqhpBwO3YBBDkcR3whrB0fG/EKhpE4M6cyhDmCw4OjBSBNzW//8ZGVhCpgGdlwvUtIZBTDecIV7sN0wet0aWkBlA52UAg2Epg7puDEM84x+YJhCN26n/GWyBmqYz1OjkAOl/yJpAbABlrVItY2gXqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = 63
// module chunks = 7